import React from 'react';
import PropTypes from 'prop-types';

import ProfileField from 'components/ProfileField';
import Button from 'components/Button';

import { Typography, Box } from '@mui/material';

import { Container } from './styles';

const Props = {
  user: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default function DeleteAccount({ user, onSave, isLoading }) {
  return (
    <Container>
      <Box p={2} bgcolor="grey.50" marginBottom={4}>
        <Typography gutterBottom={true}>
          <b>
            You can permanently delete your account at any time. Your subscription and membership
            will be canceled if it is active, and you'll lose all your creations.
            <br /> You cannot undo this.
          </b>
        </Typography>
      </Box>

      <ProfileField label="E-mail" icon="email" value={user.email} marginBottom={32} />

      <Button variant="primary" onClick={onSave} isLoading={isLoading} isInline>
        Delete Account
      </Button>
    </Container>
  );
}

DeleteAccount.propTypes = Props;
